import { EyeStroke, Pencil1Stroke, PrinterStroke, Search1Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onViewClick: () => void;
  onCopyClick: () => void;
  onSearchClick: () => void;
  onRefreshClick: () => void;
  onPrintClick: () => void;
  isDisabledView: boolean;
}

export const ActionBar = ({
  onEditClick,
  onViewClick,
  onSearchClick,
  onRefreshClick,
  isDisabledView
}: ActionBarProps) => (
  <ActionBarV2 title='Phiếu nhập điều chuyển'>
    <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isDisabledView} />
    <ActionButtonV2 icon={PrinterStroke} title='In ấn' onClick={() => {}} />
    <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isDisabledView} />
    <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} />
    <MenuButtonV2
      items={[
        {
          title: 'Refresh',
          icon: <AritoIcon icon={15} />,
          onClick: onRefreshClick,
          group: 0
        },
        {
          title: 'Cố định cột',
          icon: <AritoIcon icon={16} />,
          onClick: () => {},
          group: 0
        },

        {
          title: 'Kết xuất dữ liệu',
          icon: <AritoIcon icon={555} />,
          onClick: () => {},
          group: 1
        }
      ]}
    />
  </ActionBarV2>
);
